import { Checkbox } from "../checkbox/Checkbox";
import { CheckboxProps } from "../checkbox/CheckboxProps";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";
import { TableRowMode } from "./TableRowMode";

type TableCellConstructor<T extends TableCell = TableCell> = new (...args: any[]) => T;

export function SelectCheckboxTableCellMixin<TBase extends TableCellConstructor>(Base: TBase) {
    return class extends Base {
        private _checkbox: Checkbox;

        public get checkbox(): Checkbox {
            return this._checkbox;
        }

        private set checkbox(value: Checkbox) {
            this._checkbox = value;
            if (this.table._designer != null)
                this.checkbox.enabled = false;
            this.add(this.checkbox);
        }

        override get row(): TableRow {
            return super.row;
        }

        override set row(value: TableRow) {
            super.row = value;
            this.initializeCheckbox();
        }

        private initializeCheckbox() {
            if (this.checkbox == null && this.row.mode !== TableRowMode.QUICK_ADD) {
                this.createCheckbox();
                this.add(this.checkbox);
            }
        }

        protected createCheckbox() {
            this.checkbox = new Checkbox({
                padding: 0,
                color: "primary",
                checkSize: 28,
                ...this.addlCheckboxProps
            });
        }

        protected get addlCheckboxProps(): Partial<CheckboxProps> {
            return {};
        }
    };
}
